import React from 'react';
import classNames from 'classnames';

const SelectField = ({
  input,
  meta: { touched, error },
  options = [],
  empty,
  hideEmptyWhenHasValue = false,
  label,
  subLabel,
  readOnly,
  disabled,
  multiple,
}) => (
  <div
    className={classNames({
      'form-group': true,
      'has-error': touched && error,
      'has-success': touched && !error,
    })}
  >
    {subLabel ? (
      <>
        <label className="m-0">{label}</label>
        <br />
        <span className={subLabel.className}>{subLabel.text}</span>
      </>
    ) : (
      <>
        <label className="control-label">{label}</label>
      </>
    )}
    <select
      {...input}
      className="form-control"
      readOnly={readOnly}
      disabled={disabled}
      multiple={multiple}
    >
      {!(hideEmptyWhenHasValue && input.value) && empty && (
        <option value={''}>{empty}</option>
      )}
      {options.map((option) => (
        <option key={option[0]} value={option[0]} {...(option[2] || {})}>
          {option[1]}
        </option>
      ))}
    </select>

    {touched && error && <span className="help-block">{error}</span>}
  </div>
);

export default SelectField;
